import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import Paragraph from "@editorjs/paragraph";
import ImageTool from "@editorjs/image";
import AlignmentTuneTool from "editorjs-text-alignment-blocktune";
import FontSize from "editorjs-inline-font-size-tool";
import Undo from "editorjs-undo";
import Images from "@vtchinh/gallery-editorjs";

import Embed from "@editorjs/embed";
import DragDrop from "editorjs-drag-drop";
import ColorPlugin from "editorjs-text-color-plugin";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDTypography from "../../components/MDTypography";
import MDButton from "../../components/MDButton";
import Footer from "../../examples/Footer";
import { API_URL } from "../../constants/constants";
import MDInput from "../../components/MDInput";
import { useEffect, useRef, useState } from "react";
import { DateRange } from "react-date-range";
import "./ProductContentsEditor.css";
import ImagesIcon from "../../assets/images/icons/images-icon.svg";
import { CollinsFrontUrl } from "../../constants/constants";
import {
  dateFormatYYYYMMDDHHMM,
  dateFormatYYYYMMDDHHMMToBackEndType,
  dateYYYYMMDDFormat,
  getDataRangeInputs,
  getYmd10,
  showDataRange
} from "../../Util";
import { setSpinnerStatus, useMaterialUIController } from "../../context";
import CustomEmbedWithExtraInput from "./CustomEmbedWithExtraInput";

function ProductContentsEditor() {
  const [, dispatch] = useMaterialUIController();
  const editor = useRef(null);
  const desktopEditor = useRef(null);
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [registeredDate, setRegisteredDate] = useState(dateFormatYYYYMMDDHHMM(new Date()));
  const [duplicateCheck, setDuplicateCheck] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [boardId, setBoardId] = useState(null);
  const [writer, setWriter] = useState("");
  const [visible, setVisible] = useState(false);
  const getUserInit = async () => {
    return await fetch(API_URL + "/api/admin/info", {
      method: "GET",
      credentials: "include"
    }).then(res => res.json()).then(r => {
      setSpinnerStatus(dispatch, false);
      if (r.data) {
        setUserInfo(r.data);
        return r.data;
      }
    });
  };

  class CustomTool {
    constructor({ data }) {
      this.data = data;
      this.title = data.title || "";
      this.description = data.description || "";
    }

    render() {
      const container = document.createElement("div");
      container.className = "custom-section-block";

      const titleEl = document.createElement("div");
      titleEl.contentEditable = true;
      titleEl.className = "custom-section-title";
      titleEl.innerText = this.title;

      container.appendChild(titleEl);

      this.titleEl = titleEl;

      return container;
    }

    save() {
      return {
        title: this.titleEl.innerText
      };
    }

    static get toolbox() {
      return {
        title: "탭바 메뉴 앵커",
        icon: "🧩"
      };
    }
  }

  class PaddingTopTool {
    constructor({ data }) {
      this.margin = data.margin || "";
    }

    render() {
      const container = document.createElement("div");
      container.className = "custom-margin-block";

      const icon = document.createElement("span");
      icon.innerText = "↕️";
      icon.style.fontSize = "20px";
      icon.style.marginRight = "8px";

      const input = document.createElement("input");
      input.type = "text"; // number 타입 대신 text로 에러 방지
      input.inputMode = "numeric";
      input.pattern = "\\d*";
      input.placeholder = "상하 여백 (px)";
      input.value = this.margin;
      input.style.padding = "4px 8px";
      input.style.width = "100px";

      input.addEventListener("input", (e) => {
        const value = e.target.value;
        // 숫자 아닌 문자는 입력 안되게 필터링
        if (/^\d*$/.test(value)) {
          this.margin = value;
        } else {
          // 숫자가 아니면 이전 값으로 되돌리기
          e.target.value = this.margin;
        }
      });

      container.appendChild(icon);
      container.appendChild(input);

      this.input = input;

      return container;
    }

    save() {
      return {
        margin: this.margin
      };
    }

    static get toolbox() {
      return {
        title: "상하 여백",
        icon: "↕️"
      };
    }
  }

  class VideoUploadBlock {
    constructor({ data, config, api }) {
      this.data = {
        url: data.url || "",
        stretched: data.stretched || false
      };
      this.api = api;
      this.title = data.title || "";
      this.wrapper = undefined;
      this.config = config || {}; // { uploadFn: async (file) => { return url; } }
    }

    static get toolbox() {
      return {
        title: "Video",
        icon: `<svg width="20" height="20" viewBox="0 0 24 24"><path d="M17 10.5V7c0-1.1-.9-2-2-2H5C3.9 5 3 5.9 3 7v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-3.5l4 4v-11l-4 4z"/></svg>`
      };
    }

    render() {

      this.wrapper = document.createElement("div");
      this.wrapper.classList.add("video-block");

      this.videoElement = document.createElement("video");
      this.videoElement.controls = true;
      this.videoElement.style.maxWidth = "100%";

      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "video/*";

      fileInput.addEventListener("change", async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        this.wrapper.classList.add("is-uploading");
        const url = await this.uploadVideo(file);
        this.wrapper.classList.remove("is-uploading");

        if (url) {
          this.data.url = url;
          this.videoElement.src = url;
        }
      });

      if (this.data.url) {
        this.videoElement.src = this.data.url;
      }
      if (this.data.stretched) {
        this.wrapper.classList.add("video-block--stretched");
      }

      this.wrapper.appendChild(this.videoElement);
      this.wrapper.appendChild(fileInput);

      return this.wrapper;
    }

    async uploadVideo(file) {
      if (!this.config.uploader) {
        alert("업로드 함수 없음");
        return null;
      }

      try {
        const data = await this.config.uploader.uploadByFile(file);
        return data.file.url;
      } catch (e) {
        alert("업로드 실패");
        return null;
      }
    }

    save() {
      return {
        url: this.data.url,
        stretched: this.data.stretched
      };
    }

    validate(savedData) {
      return !!savedData.url;
    }

    renderSettings() {
      const wrapper = document.createElement("div");
      wrapper.classList.add("ce-popover__items");

      // Stretch 버튼 생성
      const stretchItem = document.createElement("div");
      stretchItem.classList.add("ce-popover-item");
      stretchItem.dataset.itemName = "stretch-video";

      const iconWrapper = document.createElement("div");
      iconWrapper.classList.add("ce-popover-item__icon");
      iconWrapper.innerHTML = `
     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M3 12h18M6 9l-3 3 3 3M18 9l3 3-3 3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

      const title = document.createElement("div");
      title.classList.add("ce-popover-item__title");
      title.textContent = "Stretch";

      stretchItem.appendChild(iconWrapper);
      stretchItem.appendChild(title);

      // 상태 active 여부에 따라 스타일 조정
      if (this.data.stretched) {
        stretchItem.classList.add("ce-popover-item--active");
      }

      stretchItem.addEventListener("click", () => {
        this.data.stretched = !this.data.stretched;
        this.wrapper.classList.toggle("video-block--stretched", this.data.stretched);
        stretchItem.classList.toggle("ce-popover-item--active", this.data.stretched);
      });

      wrapper.appendChild(stretchItem);

      return wrapper;
    }
  }


  useEffect(() => {
    setSpinnerStatus(dispatch, true);
    editor.current = new EditorJS({
      /**
       * Id of Element that should contain the ProductContentsEditor
       */
      holder: "editorjs",

      /**
       * Available Tools list.
       * Pass Tool's class or Settings object for each Tool you want to use
       */
      tools: {
        Color: {
          class: ColorPlugin, // if load from CDN, please try: window.ColorPlugin
          config: {
            colorCollections: ["#EC7878", "#9C27B0", "#673AB7", "#3F51B5", "#0070FF", "#03A9F4", "#00BCD4", "#4CAF50", "#8BC34A", "#CDDC39", "#FFF"],
            defaultColor: "#FF1300",
            type: "text",
            customPicker: true // add a button to allow selecting any colour
          }
        },

        embed: {
          class: CustomEmbedWithExtraInput,
          inlineToolbar: true,
          tunes: ["option"],
          config: {
            services: {
              youtube: true
            }
          }
        },
        image: {
          class: ImageTool,
          config: {
            // endpoints: {
            //   byFile: "http://localhost:8008/uploadFile", // Your backend file uploader endpoint
            //   byUrl: "http://localhost:8008/fetchUrl" // Your endpoint that provides uploading by Url
            // }

            uploader: {
              uploadByFile(file) {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("fileType", "img");
                return fetch(API_URL + "/api/collins/productPage/upload", {
                  method: "POST",
                  body: formData,
                  credentials: "include"
                }).then((response) => {
                  return response.json().then((res) => {
                    return {
                      success: 1,
                      file: {
                        url: res.data
                      }
                    };
                  });
                });
              }
            }
          }
        },
        Images: {
          class: Images,
          toolbox: {
            title: "Image Slide",
            icon: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve">
<metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata>
<g><path d="M794,959.4L71.3,769.5l196-722.8L990,236.6L794,959.4z M910.4,285.6L310.1,126.4l-116.4,441l594.1,159.3L910.4,285.6L910.4,285.6z M377.5,414.3l36.8,67.4l104.1-98l55.1,91.9L714.4,353l36.8,281.8L291.8,512.3L377.5,414.3z M402,346.9c-24.5-6.1-36.7-36.8-30.6-61.3c6.1-24.5,30.6-42.9,61.3-30.6c24.5,6.1,42.9,36.8,36.8,61.3C457.1,340.8,432.6,353,402,346.9z M689.9,120.3l-12.3,6.1L549,89.6l183.8-49l30.6,104.1l-73.5-18.4V120.3L689.9,120.3z M89.6,279.5l42.9,153.1L95.8,555.1L10,230.5l189.9-49L175.4,255L89.6,279.5L89.6,279.5z M206,953.3l-36.8-128.6L420.4,892L206,953.3z"/></g>
</svg>`
          },
          // tunes: [{ name: "carousel" }],
          config: {
            uploader: {
              uploadByFile(file) {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("fileType", "img");
                return fetch(API_URL + "/api/collins/productPage/upload", {
                  method: "POST",
                  body: formData,
                  credentials: "include"
                }).then((response) => {
                  return response.json().then((res) => {
                    return {
                      success: 1,
                      file: {
                        url: res.data
                      }
                    };
                  });
                });
              }
            }
          }
        },
        navigation: {
          class: CustomTool
        },
        video: {
          class: VideoUploadBlock,
          config: {
            uploader: {
              uploadByFile(file) {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("fileType", "mp4");
                return fetch(API_URL + "/api/collins/productPage/upload", {
                  method: "POST",
                  body: formData,
                  credentials: "include"
                }).then((response) => {
                  return response.json().then((res) => {
                    return {
                      success: 1,
                      file: {
                        url: res.data
                      }
                    };
                  });
                });
              }
            }
          }
        },
        padding: {
          class: PaddingTopTool
        },
        option: {
          class: AlignmentTuneTool,
          config: {
            default: "left",
            blocks: {
              header: "center"
            }
          }
        }
      },

      onReady: () => {
        new Undo({ editor: editor.current });
        new DragDrop(editor.current);
        getUserInit().then((r) => getProductContentDetail(r)
        );
      }
    });

    desktopEditor.current = new EditorJS({
      /**
       * Id of Element that should contain the ProductContentsEditor
       */
      holder: "desktopEditorjs",

      /**
       * Available Tools list.
       * Pass Tool's class or Settings object for each Tool you want to use
       */
      tools: {
        fontSize: FontSize,
        Color: {
          class: ColorPlugin, // if load from CDN, please try: window.ColorPlugin
          config: {
            colorCollections: ["#EC7878", "#9C27B0", "#673AB7", "#3F51B5", "#0070FF", "#03A9F4", "#00BCD4", "#4CAF50", "#8BC34A", "#CDDC39", "#FFF"],
            defaultColor: "#FF1300",
            type: "text",
            customPicker: true // add a button to allow selecting any colour
          }
        },
        embed: {
          class: Embed,
          inlineToolbar: true,
          tunes: ["option"],
          config: {
            services: {
              youtube: true
            }
          }
        },
        image: {
          class: ImageTool,
          config: {
            // endpoints: {
            //   byFile: "http://localhost:8008/uploadFile", // Your backend file uploader endpoint
            //   byUrl: "http://localhost:8008/fetchUrl" // Your endpoint that provides uploading by Url
            // }
            uploader: {
              uploadByFile(file) {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("fileType", "img");
                return fetch(API_URL + "/api/collins/productPage/upload", {
                  method: "POST",
                  body: formData,
                  credentials: "include"
                }).then((response) => {
                  return response.json().then((res) => {
                    return {
                      success: 1,
                      file: {
                        url: res.data
                      }
                    };
                  });
                });
              }
            }
          }
        },
        Images: {
          class: Images,
          toolbox: {
            title: "Image Slide",
            icon: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve">
<metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata>
<g><path d="M794,959.4L71.3,769.5l196-722.8L990,236.6L794,959.4z M910.4,285.6L310.1,126.4l-116.4,441l594.1,159.3L910.4,285.6L910.4,285.6z M377.5,414.3l36.8,67.4l104.1-98l55.1,91.9L714.4,353l36.8,281.8L291.8,512.3L377.5,414.3z M402,346.9c-24.5-6.1-36.7-36.8-30.6-61.3c6.1-24.5,30.6-42.9,61.3-30.6c24.5,6.1,42.9,36.8,36.8,61.3C457.1,340.8,432.6,353,402,346.9z M689.9,120.3l-12.3,6.1L549,89.6l183.8-49l30.6,104.1l-73.5-18.4V120.3L689.9,120.3z M89.6,279.5l42.9,153.1L95.8,555.1L10,230.5l189.9-49L175.4,255L89.6,279.5L89.6,279.5z M206,953.3l-36.8-128.6L420.4,892L206,953.3z"/></g>
</svg>`
          },
          config: {
            uploader: {
              uploadByFile(file) {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("fileType", "img");
                return fetch(API_URL + "/api/collins/productPage/upload", {
                  method: "POST",
                  body: formData,
                  credentials: "include"
                }).then((response) => {
                  return response.json().then((res) => {
                    return {
                      success: 1,
                      file: {
                        url: res.data
                      }
                    };
                  });
                });
              }
            }
          }
        },
        navigation: {
          class: CustomTool
        },
        video: {
          class: VideoUploadBlock,
          config: {
            uploader: {
              uploadByFile(file) {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("fileType", "mp4");
                return fetch(API_URL + "/api/collins/productPage/upload", {
                  method: "POST",
                  body: formData,
                  credentials: "include"
                }).then((response) => {
                  return response.json().then((res) => {
                    return {
                      success: 1,
                      file: {
                        url: res.data
                      }
                    };
                  });
                });
              }
            }
          }
        },
        padding: {
          class: PaddingTopTool
        },
        option: {
          class: AlignmentTuneTool,
          config: {
            default: "left",
            blocks: {
              header: "center"
            }
          }
        }
      },


      onReady: () => {
        new Undo({ editor: desktopEditor.current });
        new DragDrop(desktopEditor.current);
        getUserInit().then((r) => getProductContentDetail(r)
        );
      }
    });
  }, []);

  const getProductContentDetail = (userData) => {
    const searchParams = new URLSearchParams(window.location.search);
    const boardIdParams = searchParams.get("id");
    setBoardId(boardIdParams);
    if (boardIdParams) {
      setSpinnerStatus(dispatch, true);
      fetch(API_URL + "/api/collins/productPage/contents/" + boardIdParams, {
        method: "GET",
        credentials: "include"
      }).then(res => {
        setSpinnerStatus(dispatch, false);
        if (res.status !== 200) {
          window.location.href = "/collins/productContentList";
          return window.alert("잘못된 접근입니다.");
        }
        return res.json();
      }).then(r => {
        if (r.data) {
          setTitle(r.data.title);
          setSlug(r.data.slug);
          setWriter(r.data.writer);
          if (r.data.slug.trim().length > 0) {
            setDuplicateCheck(true);
          }
          setRegisteredDate(dateFormatYYYYMMDDHHMM(new Date(r.data.register_date)));
          console.log(r.data);
          setVisible(Boolean(r.data.use_yn));
          if (r.data.mobile_content) {
            editor.current.render({ blocks: JSON.parse(r.data.mobile_content) });
          }
          if (r.data.desktop_content) {
            desktopEditor.current.render({ blocks: JSON.parse(r.data.desktop_content) });
          }
        }
      });
    } else {
      setWriter(userData.email);
    }
  };

  const saveBoard = () => {
    if (title.trim().length === 0) {
      alert("제목을 입력해주세요.");
      return;
    } else if (!duplicateCheck) {
      alert("슬러그를 중복 체크 해주세요.");
      return;
    } else {
      editor.current.save().then((outputData) => {
        desktopEditor.current.save().then(desktopData => {
          const data = {
            title: title,
            slug: slug,
            mobile_content: JSON.stringify(outputData.blocks),
            desktop_content: JSON.stringify(desktopData.blocks),
            use_yn: visible,
            register_date: dateFormatYYYYMMDDHHMMToBackEndType(new Date(registeredDate))
          };
          setSpinnerStatus(dispatch, true);
          fetch(API_URL + "/api/collins/productPage/contents", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(data),
            credentials: "include"
          }).then((response) => {
              response.json().then(
                (res) => {
                  setSpinnerStatus(dispatch, false);
                  if (res.code === "200") {
                    alert("저장 되었습니다.");
                    window.location.href = "/collins/productContent/editor?id=" + res.data;
                  } else {
                    alert("오류가 발생했습니다.");
                  }
                });
            }
          );
        });
      });
    }
  };

  const modifyBoard = () => {
    if (title.trim().length === 0) {
      alert("제목을 입력해주세요.");
      return;
    } else if (!duplicateCheck) {
      alert("슬러그를 중복 체크 해주세요.");
      return;
    } else {
      editor.current.save().then((outputData) => {
        desktopEditor.current.save().then(desktopData => {
          const data = {
            title: title,
            slug: slug,
            mobile_content: JSON.stringify(outputData.blocks),
            desktop_content: JSON.stringify(desktopData.blocks),
            use_yn: visible,
            register_date: dateFormatYYYYMMDDHHMMToBackEndType(new Date(registeredDate))
          };
          setSpinnerStatus(dispatch, true);
          fetch(API_URL + "/api/collins/productPage/contents/" + boardId, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(data),
            credentials: "include"
          }).then((response) => {
            setSpinnerStatus(dispatch, false);
            if (response.ok) {
              alert("수정 되었습니다.");
              // window.location.href = "/brandArchive";
            } else {
              alert("오류가 발생했습니다.");
            }
          });
        });
      });
    }
  };

  const checkDuplicatedSlug = () => {
    if (slug.trim().length === 0) {
      alert("슬러그를 입력해주세요.");
      return;
    } else {
      setSpinnerStatus(dispatch, true);
      fetch(API_URL + "/api/collins/productPage/contents/slug/check?keyword=" + slug, {
        method: "GET",
        credentials: "include"
      }).then((response) => {
        response.json().then((res) => {
          setSpinnerStatus(dispatch, false);
          if (res.data) {
            setDuplicateCheck(true);
            alert("사용 가능한 슬러그입니다.");
          } else {
            alert("이미 사용중인 슬러그입니다.");
          }
        });
      });
    }
  };

  const deleteBoard = () => {
    if (window.confirm("정말 삭제하시겠습니까?")) {
      setSpinnerStatus(dispatch, true);
      fetch(API_URL + "/api/collins/productPage/contents/" + boardId, {
        method: "DELETE",
        credentials: "include"
      }).then((response) => {
        setSpinnerStatus(dispatch, false);
        if (response.ok) {
          alert("삭제 되었습니다.");
          window.location.href = "/collins/productContentList";
        } else {
          alert("오류가 발생했습니다.");
        }
      });
    }
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  COLLINS
                </MDTypography>
                <MDTypography variant="h6" color="white">
                  제품 상세페이지 콘텐츠 {boardId ? "수정하기" : "작성하기"}
                </MDTypography>
              </MDBox>
              <MDBox mt={2} mx={2} px={2} display="flex">
                <MDBox width="100%" mr={1}>
                  <MDTypography component="div" variant="caption" color="text" fontSize="16px" fontWeight="medium">
                    제목(최대 40자 이하)
                  </MDTypography>
                  <MDInput style={{ width: "100%" }} value={title} onChange={(e) => setTitle(e.target.value)} />
                </MDBox>
                <MDBox>
                  <MDBox display="flex" justifyContent="space-between" alignItem="center">
                    <MDTypography component="div" variant="caption" color="text" fontSize="16px" fontWeight="medium">
                      Slug
                    </MDTypography>
                    <MDButton color={duplicateCheck ? "success" : "error"}
                              style={{ padding: "0", minHeight: 0, height: "18px" }}
                              onClick={() => {
                                checkDuplicatedSlug();
                              }}>중복 체크</MDButton>
                  </MDBox>
                  <MDInput value={slug} onChange={(e) => {
                    setSlug(e.target.value);
                    setDuplicateCheck(false);
                  }} />
                </MDBox>
              </MDBox>
              <div className="product-content-grid-wrapper">
                <MDBox pt={3} mx={1} px={1} my={2} border={"1px solid rgba(0, 0, 0, 0.125)"}>
                  <MDBox pb={3} px={2} borderBottom={"1px solid rgba(0, 0, 0, 0.125)"}>
                    <MDTypography>모바일 (768px 미만)</MDTypography>
                  </MDBox>
                  <div id="editorjs"></div>
                </MDBox>
                <MDBox pt={3} mx={1} px={1} my={2} border={"1px solid rgba(0, 0, 0, 0.125)"}>
                  <MDBox pb={3} px={2} borderBottom={"1px solid rgba(0, 0, 0, 0.125)"}>
                    <MDTypography>데스크탑 (768px 이상)</MDTypography>
                  </MDBox>
                  <div id="desktopEditorjs"></div>
                </MDBox>
              </div>
              <MDBox my={1} mx={2} px={2} display={"flex"}>
                <MDBox display={"flex"} mb={1} height="fit-content">
                  <MDTypography component="div" variant="caption" color="text" fontSize="16px" fontWeight="medium">
                    활성화
                  </MDTypography>
                  <input checked={visible} onChange={() => setVisible(!visible)} type={"checkbox"}
                         style={{ marginLeft: "4px" }} />
                </MDBox>
              </MDBox>
              <MDBox display="flex" mx={2}
                     mt={2}
                     py={3}
                     px={2}>
                <MDBox display="flex">
                  {boardId ? <MDBox display="flex">
                    <MDBox mr={1}><MDButton color="info" onClick={() => {
                      modifyBoard();
                    }}>수정하기</MDButton></MDBox>
                    <MDButton color="info" onClick={() => {
                      deleteBoard();
                    }}>삭제하기</MDButton>
                  </MDBox> : <MDButton color="info" onClick={() => {
                    saveBoard();
                  }}>저장하기</MDButton>}
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>

  );
}

export default ProductContentsEditor;

